import {Service} from "@/services/superclasses/service";
import {Country} from "@/interfaces/country";

const api = window.contextPath + '/rest/countries';

export class CountryService extends Service {

    constructor() {
        super()
    }

    public loadById = async (id: number): Promise<Country> => {
        return this.data(await this.get<Country>(api + "/" + id))
    }

    public loadAll = async (): Promise<Country[]> => {
        return this.data(await this.get<Country[]>(api))
    };

    public hostCountriesFirst = async (): Promise<Country[]> => {
        return this.data(await this.get<Country[]>(api + "/host-countries-first"))
    };
}

export const countryService = new CountryService()
